import React from 'react'
import { withContext } from 'ddiForm'
import { getIn, is } from 'utils'
import { useDispatch } from 'react-redux'
import { Button } from '@material-ui/core'
import { debounce, noop } from 'lodash'
import { removeModal } from 'modals/actions'
import { handleSwapCommittedQuantitiesInteraction } from '../../../actions'

const marginRight = { marginRight: 5 }

const ActionButtons = ({
  balance,
  form,
  modalId,
  lineNumber,
  onClickLoadScheduleButton = noop
}) => {
  const dispatch = useDispatch()

  const cancelSwapCommittedQuantities = debounce(e => {
    dispatch(
      handleSwapCommittedQuantitiesInteraction.try(form, {
        apiParams: {
          action: 'cancel',
          lineNumber
        },
        modalId
      })
    )
  }, 300)

  const commitSwappedQuantities = debounce(e => {
    dispatch(
      handleSwapCommittedQuantitiesInteraction.try(form, {
        apiParams: {
          action: 'ok',
          lineNumber
        },
        modalId
      })
    )
  }, 300)

  return (
    <div
      className="sales-order-entry-modal-action-buttons"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '10px 0 0 0'
      }}
    >
      <Button
        onClick={commitSwappedQuantities}
        variant="contained"
        style={marginRight}
        tabIndex={-1}
      >
        OK
      </Button>
      <Button
        onClick={cancelSwapCommittedQuantities}
        variant="contained"
        tabIndex={-1}
      >
        Exit
      </Button>
    </div>
  )
}

export default ActionButtons
